import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useParams } from "react-router-dom";

import { showToast } from "../ToastManager";
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";
import { Fieldset } from 'primereact/fieldset';
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";

import UsuarioService from "../../service/UsuarioService";
import EmpresaService from '../../service/EmpresaService';
import ConfigsService from '../../service/ConfigsService';
import CpfCnpjDisplay from '../../utilities/CpfCnpjDisplay';

const configService = new ConfigsService();
const empresaService = new EmpresaService();
const usuarioService = new UsuarioService();

const CadastrarUsuario = () => {
    const iss = localStorage.getItem('iss');
    const history = useHistory();

    let usuarioNovo = {
        username: null,
        email: null,
        password: null,
        companyId: null,
        roleId: null,
        ativo: null,
        excluido: null,
        isEmpresaAdm: null,
        companyId: null,
        roleId: null,
        profile: {
            name: null,
            nickname: null,
            cpf: null,
            cnpj: null,
            gender: null,
            phone: null,
            bio: null,
            location: null,
            referred_by_employee: null,
            referrer_name: null
        },
        companiesRoles: [],
    };

    const [usuario, setUsuario] = useState(usuarioNovo);
    const [empresa, setEmpresa] = useState([]);
    const [role, setRole] = useState([]);
    const [selectedEmpresa, setSelectedEmpresa] = useState(null);
    const [selectedRole, setSelectedRole] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(false);

    const { id } = useParams();

    useEffect(() => {
        initEmpresa();
        initRole();
    }, []);

    const initEmpresa = () => {
        setLoading(true);
        empresaService.listAllEmpresa(iss).then(data => {
            const updatedItems = data.data.rows.map(({ cnpj, razaoSocial, telefone, endereco, cidade, estado, cep, excluido, ativo, createdAt, updatedAt, ...rest }) => rest);
            setEmpresa(updatedItems);
            setLoading(false);
        });
    }

    const initRole = () => {
        setLoading(true);
        configService.listAllRoles(iss).then(data => {
            const updatedItems = data.data.rows.map(({ ativo, createdAt, updatedAt, ...rest }) => rest);
            setRole(updatedItems);
            setLoading(false);
        });
    }

    useEffect(() => {
        if (id != null) {
            setLoading(true);
            setDisable(true)
            usuarioService.getUser(iss, id).then(data => {
                setLoading(false);
                usuarioNovo = data.data.rows[0];
                usuarioNovo.companyId = usuarioNovo.companiesRoles[0].company_id
                usuarioNovo.roleId = usuarioNovo.companiesRoles[0].role_id
                setTimeout(() => {
                    setSelectedEmpresa(usuarioNovo.companiesRoles[0].company)
                    setSelectedRole(usuarioNovo.companiesRoles[0].role)
                    setUsuario(usuarioNovo);
                }, 200);
            });
        }
    }, []);

    const onInputChange = (e, name, list = false, checkbox = false,) => {
        let val = (e.target && e.target.value) || '';

        if (checkbox) {
            val = e.checked;
        }

        if (name === 'companyId') {
            setSelectedEmpresa(e.value)
            val = e.value.id;
        }

        if (name === 'roleId') {
            setSelectedRole(e.value)
            val = e.value.id;
        }

        let _usuario = { ...usuario };
        if (name.includes('.')) {
            const [parent, child] = name.split('.');
            if (!_usuario[parent]) {
                _usuario[parent] = {};
            }
            _usuario[parent][child] = val;
        } else {
            if (list) {
                _usuario[name] = val;
            } else {
                _usuario[name] = val;
            }
        }

        setUsuario(_usuario);
    }

    const cadastrar = () => {
        setSubmitted(true);
        if (usuario.username && usuario.email && usuario.companyId && usuario.roleId) {
            let { status, profile, companiesRoles, ..._usuario } = usuario;

            setLoading(true)
            if (usuario.id != null) {
                usuarioService.changeRoleUser(iss, _usuario, usuario.id).then(data => {
                    showToast({ severity: 'success', summary: 'Cadastro de usuário', detail: 'Usuário editada com sucesso' });
                    history.push('/usuarios/listar');
                    return;
                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao editar', detail: 'Erro ao editar usuário' });
                }).finally(() => { setLoading(false) });
            } else {
                usuarioService.postUser(iss, _usuario).then(data => {
                    showToast({ severity: 'success', summary: 'Cadastro de usuário', detail: 'Usuário cadastrada com sucesso' });
                    history.push('/usuarios/listar');
                    return;
                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao cadastrar', detail: error.response.data.error.message });
                }).finally(() => { setLoading(false) });
            }
        }
    }

    const verificaSeExisteCPFEmail = (e) => {
        let val = (e.target && e.target.value) || '';
        let msg = ''
        let search = ''
        if (val.includes("@") && val.length > 11) {
            msg = 'Email'
            search = `email=${val}`
        } else {
            msg = 'CPF'
            val = String(val).replace(/[^\d]/g, '')
            search = `cpf=${val}`
        }

        setLoading(true);
        usuarioService.getUserFilter(iss, search).then(data => {
            setLoading(false);
            if (data.data.count > 0) {
                showToast({ severity: 'error', summary: 'Conflito', detail: `${msg} já cadastrado` });
            }
        }, error => {
            setLoading(false);
            showToast({ severity: 'error', summary: 'Conflito', detail: `${msg} já cadastrado` });
        });
    };

    return (
        <div className="grid">
            <h4>Informações do usuário</h4>
            <div className="col-12">
                <div className="card">
                    <div style={{ marginTop: 10 }} className="p-fluid formgrid grid">
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-6">
                            <span className="p-float-label">
                                <InputText value={usuario.username} onChange={(e) => onInputChange(e, 'username')}
                                    className={classNames({ 'p-invalid': submitted && !usuario.username })} required id="username" type="text" disabled={disable}
                                />
                                <label htmlFor="nome">Nome de usuário</label>
                            </span>
                            {submitted && !usuario.username && <small className="p-invalid">Nome de usuário é obrigatório.</small>}
                        </div>
                        <div style={{ marginTop: 10 }} className="field col-6">
                            <span className="p-float-label">
                                <InputText value={usuario.email}
                                    onBlur={(e) => verificaSeExisteCPFEmail(e)}
                                    onChange={(e) => onInputChange(e, 'email')}
                                    className={classNames({ 'p-invalid': submitted && (!usuario.email || (usuario.email != null && !usuario.email.includes('@'))) })}
                                    required
                                    disabled={disable}
                                    id="email" type="text" />
                                <label htmlFor="email">Email</label>
                            </span>
                            {submitted && !usuario.email &&
                                <small className="p-invalid">Email é obrigatório.</small>}

                            {submitted && usuario.email != null && !usuario.email.includes('@') &&
                                <small className="p-invalid">Email inválido.</small>}
                        </div>

                        <div style={{ marginTop: 20 }} className="field col-12 md:col-6">
                            <span className="p-float-label">
                                <Dropdown optionLabel="name" value={selectedEmpresa}
                                    className={classNames({ 'p-invalid': submitted && !usuario.companyId })}
                                    options={empresa}
                                    disabled={disable}
                                    onChange={(e) => {
                                        onInputChange(e, 'companyId')
                                    }} />
                                <label htmlFor="companyId">Empresa</label>
                            </span>
                            {submitted && !selectedEmpresa &&
                                <small className="p-invalid">Empresa é obrigatório.</small>}
                        </div>
                        <div style={{ marginTop: 20 }} className="field col-12 md:col-6">
                            <span className="p-float-label">
                                <Dropdown optionLabel="name" value={selectedRole}
                                    className={classNames({ 'p-invalid': submitted && !usuario.roleId })}
                                    options={role}
                                    onChange={(e) => {
                                        onInputChange(e, 'roleId')
                                    }} />
                                <label htmlFor="roleId">Perfil de acesso</label>
                            </span>
                            {submitted && !selectedRole &&
                                <small className="p-invalid">Perfil de acesso é obrigatório.</small>}
                        </div>
                        <div className="col-12 md:col-4">
                            <div className="field-checkbox">
                                <Checkbox inputId="isEmpresaAdm" name="isEmpresaAdm"
                                    checked={usuario.isEmpresaAdm}
                                    onChange={(e) => {
                                        onInputChange(e, 'isEmpresaAdm', false, true)
                                    }} />
                                <label htmlFor="isEmpresaAdm">Usuário administrador da empresa</label>
                            </div>
                        </div>
                        {disable && (
                            <>
                                <div className="col-12">
                                    <div className="card">
                                        <h5>Perfil</h5>
                                        <Fieldset>
                                            <div style={{ marginTop: 10 }} className="p-fluid formgrid grid">
                                                <div style={{ marginTop: 10 }} className="field col-12 md:col-6">
                                                    <span className="p-float-label">
                                                        <InputText value={usuario.profile.name} id="usuario.profile.name" type="text" disabled={disable} />
                                                        <label htmlFor="name">Nome</label>
                                                    </span>
                                                </div>

                                                {/* Componente unificado para CPF/CNPJ */}
                                                <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                                                    <CpfCnpjDisplay
                                                        cpf={usuario.profile.cpf}
                                                        cnpj={usuario.profile.cnpj}
                                                        disabled={disable}
                                                    />
                                                </div>

                                                <div style={{ marginTop: 10 }} className="field col-12 md:col-2">
                                                    <span className="p-float-label">
                                                        <InputText value={usuario.profile.gender} id="usuario.profile.gender" type="text" disabled={disable} />
                                                        <label htmlFor="usuario.profile.gender">Gênero</label>
                                                    </span>
                                                </div>
                                                <div style={{ marginTop: 10 }} className="field col-12 md:col-2">
                                                    <span className="p-float-label">
                                                        <InputMask value={usuario.profile.phone}
                                                            disabled={disable}
                                                            mask={"(99) 9.9999-9999"}
                                                            id="usuario.profile.phone" type="text" />
                                                        <label htmlFor="usuario.profile.phone">Telefone</label>
                                                    </span>
                                                </div>
                                                <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                                                    <span className="p-float-label">
                                                        <InputText
                                                            value={usuario.profile.referred_by_employee ? 'Sim' : 'Não'}
                                                            id="usuario.profile.referred_by_employee"
                                                            type="text"
                                                            disabled={disable}
                                                        />
                                                        <label htmlFor="usuario.profile.referred_by_employee">Indicado por funcionário</label>
                                                    </span>
                                                </div>
                                                <div style={{ marginTop: 10 }} className="field col-12 md:col-6">
                                                    <span className="p-float-label">
                                                        <InputText
                                                            value={usuario.profile.referrer_name || ''}
                                                            id="usuario.profile.referrer_name"
                                                            type="text"
                                                            disabled={disable}
                                                        />
                                                        <label htmlFor="usuario.profile.referrer_name">Nome de quem indicou</label>
                                                    </span>
                                                </div>
                                            </div>
                                        </Fieldset>
                                    </div>
                                </div>
                            </>
                        )}

                        <Button label={id != null ? 'Atualizar' : 'Cadastrar'} loading={loading} style={{ width: '100%', marginTop: 10 }}
                            onClick={cadastrar} className="mr-2 mb-2"></Button>

                        <div onClick={history.goBack} style={{ width: '100%', marginTop: 10, textAlign: 'center', cursor: 'pointer' }}>
                            <i className="pi pi-arrow-left"></i><span style={{ marginLeft: 10, }}>Voltar</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(CadastrarUsuario, comparisonFn);